import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-gtag';
import { EuiSpacer } from '@elastic/eui';
import DangerBox from "components/Indoor_Cameras/IN-8415_WQHD/Camera_Reset/DangerBox";
import PrimaryBox from "components/Indoor_Cameras/IN-8415_WQHD/Camera_Reset/PrimaryBox";
import NavButtons from 'components/Indoor_Cameras/IN-8415_WQHD/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "INSTAR IN-8415 2k+ WQHD Werksreset",
  "path": "/Innenkameras/IN-8415_WQHD/Kamera_Reset/",
  "dateChanged": "2018-01-22",
  "author": "Mike Polinowski",
  "excerpt": "INSTAR IN-8415 WQHD Outdoor IP Kamera Werkseinstellung",
  "image": "./P_SearchThumb_IN-8415WQHD_Reset.webp",
  "social": "/images/Search/P_SearchThumb_IN-8415WQHD_Reset.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_P-IN-8415WQHD_white.webp",
  "chapter": "Indoor Cameras"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <SEOHelmet title='IN-8415 2k+ WQHD Werksreset' dateChanged='2017-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='INSTAR IN-8415 WQHD Outdoor IP Kamera Werkseinstellung' image='/images/Search/P_SearchThumb_IN-8415WQHD_Reset.png' twitter='/images/Search/P_SearchThumb_IN-8415WQHD_Reset.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Indoor_Cameras/IN-8415_WQHD/Camera_Reset/' locationFR='/fr/Indoor_Cameras/IN-8415_WQHD/Camera_Reset/' crumbLabel="Reset" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <h2 {...{
      "id": "wiederherstellen-der-werkseinstellungen-ihrer-kamera",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#wiederherstellen-der-werkseinstellungen-ihrer-kamera",
        "aria-label": "wiederherstellen der werkseinstellungen ihrer kamera permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Wiederherstellen der Werkseinstellungen Ihrer Kamera`}</h2>
    <h3 {...{
      "id": "über-die-weboberfläche-ihrer-kamera",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#%C3%BCber-die-weboberfl%C3%A4che-ihrer-kamera",
        "aria-label": "über die weboberfläche ihrer kamera permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Über die Weboberfläche Ihrer Kamera`}</h3>
    <p>{`Wenn Sie noch Zugriff auf Ihre Kamera über Ihren Webbrowser haben, können Sie die `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Series/System/Reset/"
      }}>{`Weboberfläche zum Zurücksetzen Ihrer Kamera verwenden`}</a>{`.`}</p>
    <DangerBox mdxType="DangerBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "über-die-hardware-reset-taste",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#%C3%BCber-die-hardware-reset-taste",
        "aria-label": "über die hardware reset taste permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Über die Hardware-Reset-Taste`}</h3>
    <p>{`Halten Sie zum Zurücksetzen die Reset-Taste `}<strong parentName="p">{`20 Sekunden lang gedrückt`}</strong>{` (siehe unten), während die Kamera über das Netzteil mit Strom versorgt wird und das LAN-Kabel entfernt ist.`}</p>
    <PrimaryBox mdxType="PrimaryBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    {
      /*
      ### Über die SD-Karte
      Wenn Sie keinen Zugriff mehr auf die Weboberfläche haben und der Reset-Knopf beschädigt ist, haben Sie den Reset noch auf der SD-Karte Ihrer Kamera. Legen Sie dafür eine Datei an und geben Sie ihr den Namen **reset** (ganz wichtig **ohne Dateiendung**!) - unter Windows ist das nicht so einfach, deshalb haben wir die notwendige Datei <OutboundLink href="https://wiki.instar.com/dl/IN-9008HD/wps_reset.zip">hier zum Download</OutboundLink>. Die Datei ist gepackt und muss erst aus dem Zip-Container befreit werden, bevor wir sie verwenden können.
      #### Zurücksetzen der Kamera
      **zurücksetzen** : Entnehmen Sie die SD-Karte aus der Kamera und schließen Sie die Karte über ein Kartenlesegerät an den Computer an. Legen Sie dann die Datei im **Root-Verzeichnis** (d.h. direkt auf der Karte, nicht in einem Unterordner) der Speicherkarte ab und werfen Sie anschließend die SD-Karte aus. Um die Kamera auf die Werkseinstellungen zurückzusetzen, stecken Sie bitte die SD-Karte wieder in den Kartenslot der Kamera und starten Sie die Kamera neu.
      
      ![INSTAR IN-8415 2k+ WQHD Kamera Hardware Reset](./reset_wps_by_sd_card.png)
      */
    }
    <h4 {...{
      "id": "wlan-integration-nach-dem-zurücksetzen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#wlan-integration-nach-dem-zur%C3%BCcksetzen",
        "aria-label": "wlan integration nach dem zurücksetzen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`WLAN-Integration nach dem Zurücksetzen`}</h4>
    <p><strong parentName="p">{`wps`}</strong>{` : Um die Kamera nach dem Neustart wieder mit dem WLAN-Netzwerk zu verbinden, kann man eine Datei namens `}<strong parentName="p">{`wps`}</strong>{` (ganz wichtig `}<strong parentName="p">{`ohne Dateiendung`}</strong>{`!) erstellen - unter Windows ist das nicht so einfach, daher haben wir die notwendige Datei `}<OutboundLink href="https://wiki.instar.com/dl/IN-9008HD/wps_reset.zip" mdxType="OutboundLink">{`hier zum Download bereitgestellt`}</OutboundLink>{`. Die Datei ist gepackt und muss erst aus dem Zip-Container befreit werden, bevor wir sie verwenden können. Legen Sie diese Datei im `}<strong parentName="p">{`Root-Verzeichnis`}</strong>{` (d.h. direkt auf der Karte, nicht in einem Unterordner) der Speicherkarte ab und stecken Sie sie dann wieder in den Kartenslot Ihrer Kamera. Starten Sie dann den `}<a parentName="p" {...{
        "href": "/de/Schnell_Installation/Herstellen_der_WLAN_Verbindung/WPS_Plug_and_Play/"
      }}>{`WPS Modus Ihres WLAN Routers`}</a>{` und starten Sie die Kamera neu. Nach dem Neustart befindet sich die Kamera im WPS-Modus und versucht, sich mit Ihrem Router zu verbinden.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      